import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router";
import { MsalContext } from "src/components/Contexts/MsalContext";
import { NewIndexViewModel } from "../../ViewModels/IndexContainerViewModels";
import MonitoringCallIndexTable from "./MonitoringCallIndexTable";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import CallTableViewModel, { CallTableFilters } from "../../ViewModels/CallTableViewModel";

interface IMonitoringCallIndexContainer {
    callId: string
    customerId: string | null
    setId: (newId: string) => void
    callSwitchEnabled: boolean
}

export default function MonitoringCallIndexContainer(props: IMonitoringCallIndexContainer) {
    const { msalFetch } = useContext(MsalContext);
    const { search } = useLocation();
    const [calls, setCalls] = useState(new NewIndexViewModel());
    const [filters, setFilters] = useState<CallTableViewModel | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [failedToLoad, setFailedToLoad] = useState<boolean>(false);

    const params = new URLSearchParams(search);
    const clientParam = params.get("client") ?? '';

    useEffect(() => {
        if (props.customerId) {
            let date = new Date();
            date.setFullYear(date.getFullYear() - 1);

            const intiCallTable = new CallTableViewModel;
            const filters: CallTableFilters = intiCallTable.filters;
            filters.client = clientParam;

            filters.dateTimeFilters.preset = 'Date Range';
            filters.customerFilters.isActive = true;
            filters.customerFilters.customerID = props.customerId;
            filters.dateTimeFilters.startDate = date;
            intiCallTable.filters = filters;

            //const initFilters = new FilterViewModel;
            //initFilters.flagCustomerID = true;
            //initFilters.flagDateRange = true;
            //initFilters.flagClient = true;
            //initFilters.client = clientParam;
            //initFilters.customerID = props.customerId;
            //initFilters.startDate = date;
            setFilters(intiCallTable);
        }
    }, [])

    useEffect(() => {
        if (filters) {
            setIsLoading(true);
            filterSearch();
        }
    }, [filters])

    const filterSearch = () => {
        msalFetch('api/Search/GetCallHistory/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify(filters)
        })
            .then(response => response.json())
            .then(data => {

                data.success ? setCalls(data.value) : setFailedToLoad(true);

                setIsLoading(false)
            });

    }

    return (
        isLoading ?
            <Grid container justifyContent="center" alignItems="center">
                <Grid>
                    <CircularProgress />
                </Grid>
            </Grid>
            :
            < MonitoringCallIndexTable
                callId={props.callId}
                calls={calls.callRows}
                setId={props.setId}
                callSwitchEnabled={props.callSwitchEnabled}
                failedToLoad={failedToLoad}
            />
    )
}